var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0323 10.8223L12.5739 0.371561C12.4986 0.296111 12.4091 0.236251 12.3107 0.195409C12.2122 0.154567 12.1066 0.133545 12 0.133545C11.8934 0.133545 11.7879 0.154567 11.6894 0.195409C11.591 0.236251 11.5015 0.296111 11.4262 0.371561L0.967822 10.8223C0.663135 11.127 0.490479 11.5409 0.490479 11.9725C0.490479 12.8688 1.21919 13.5975 2.11548 13.5975H3.21743V21.0548C3.21743 21.5042 3.58052 21.8673 4.02993 21.8673H10.375V16.1798H13.2188V21.8673H19.9702C20.4196 21.8673 20.7827 21.5042 20.7827 21.0548V13.5975H21.8846C22.3163 13.5975 22.7301 13.4274 23.0348 13.1202C23.667 12.4854 23.667 11.4571 23.0323 10.8223V10.8223Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.280fa7b6e034e188b6035d99f925f64a.svg";
export { ForwardRef as ReactComponent };